// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__Kn-oH","box":"WorkspacesBox_box__9_sL9","node":"WorkspacesBox_node__1Yiay"};